import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { InAppNotificationService } from './core/notifications/in-app-notification.service';
import { normalizeAppRoute } from './core/navigation/route-normalization.util';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, TranslatePipe],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  protected readonly inAppNotificationService = inject(InAppNotificationService);

  private readonly router = inject(Router);

  protected async openInAppNotification(): Promise<void> {
    const notification = this.inAppNotificationService.current();
    this.inAppNotificationService.dismiss();

    if (!notification?.deepLink) {
      await this.router.navigateByUrl('/dashboard');
      return;
    }

    const normalizedRoute = normalizeAppRoute(notification.deepLink);
    await this.router.navigateByUrl(normalizedRoute);
  }
}
